<template>
  <b-row class="col-md-12 mb-1 m-0 p-0" v-if="isLocked">
    <b-alert
      show
      variant="warning"
      class="w-100 d-flex align-items-center mb-0"
    >
      <i
        class="fa fa-exclamation-triangle text-warning mr-2"
        style="font-size: 1.1rem"
      ></i>
      <div class="flex-grow-1">
        <span class="text-white">
          Đơn hàng đã liên kết hóa đơn
          <span
            class="text-white font-weight-bold hover-link"
            style="cursor: pointer"
            @click="openLinkedBill"
          >#{{ lock.billNumber }}</span>
          đã được tạo hóa đơn GTGT.
        </span>
        Bạn không thể chỉnh sửa đơn hàng này.
        <template v-if="invoiceNoDisplay">
          <span class="mx-2">|</span>
          Số HĐĐT: {{ invoiceNoDisplay }}
        </template>
        <template v-if="issuedAtDisplay">
          <span class="mx-2">|</span>
          Ngày phát hành: {{ issuedAtDisplay }}
        </template>
      </div>
      <EInvoiceStatusBadge
        v-if="lock.einvoice"
        class="ml-2"
        size="sm"
        :work-state="lock.einvoice.workState"
        :invoice-no="lock.einvoice.invoiceNo"
        :pattern="lock.einvoice.pattern"
        :serial="lock.einvoice.serial"
        :issued-at="lock.einvoice.issuedAt"
        :tax-status="lock.einvoice.taxStatus"
        :error-message="lock.einvoice.errorMessage"
      />
    </b-alert>
  </b-row>
</template>

<script>
  // Luồng nghiệp vụ: Order → Bill → EInvoice; Bill → Trả hàng → AdjustmentEInvoice.
  // Order chỉ gắn với einvoice (qua bill gốc), KHÔNG bao giờ gắn trực tiếp với adjustment einvoice.
  import moment from 'moment'
  import EInvoiceStatusBadge from '@/view/components/bills/EInvoiceStatusBadge.vue'

  const WHOLESALE_BILL_TYPE = 2

  export default {
    name: 'OrderEInvoiceLockAlert',
    components: { EInvoiceStatusBadge },
    props: {
      lock: {
        type: Object,
        default: null,
      },
    },
    computed: {
      isLocked() {
        return Boolean(this.lock && this.lock.billNumber)
      },
      invoiceNoDisplay() {
        if (!this.lock || !this.lock.einvoice) return ''
        return this.lock.einvoice.invoiceNo || ''
      },
      issuedAtDisplay() {
        if (!this.lock || !this.lock.einvoice) return ''
        const issuedAt = this.lock.einvoice.issuedAt
        if (!issuedAt) return ''
        const m = moment(issuedAt)
        return m.isValid() ? m.format('DD/MM/YYYY') : ''
      },
    },
    methods: {
      openLinkedBill() {
        if (!this.lock || !this.lock.billNumber) return
        const billType = Number(this.lock.billType)
        const route = billType === WHOLESALE_BILL_TYPE
          ? {
              path: '/wholesale-invoice/update-wholesale-invoice',
              query: { id: this.lock.billNumber },
            }
          : {
              path: '/bills/update-bill',
              query: { id: this.lock.billNumber },
            }
        const resolved = this.$router.resolve(route)
        window.open(resolved.href, '_blank')
      },
    },
  }
</script>
